import { useEffect } from 'react'

import { useTypedDispatch } from '../..'
import { fetchTrainPunctuality } from '../../actions/api'
import { TASK_OTHER_TRAINS_PUNCTUALITY_CUTOFF_MS } from '../../constants'
import moment from '../../lib/moment-fi'

export interface TrainPunctualityInput {
  trainNumber: string
  operatingDate: string
  timestamp: string
}

export const useTaskEquipmentPunctualityFetch = (
  enabled: boolean,
  trains: TrainPunctualityInput[],
  taskStartTimestamp: string
) => {
  const dispatch = useTypedDispatch()

  useEffect(() => {
    if (!enabled || !trains.length) return

    const taskStart = moment(taskStartTimestamp)
    const trainsToFetch = trains.filter(
      ({ trainNumber, operatingDate, timestamp }) =>
        trainNumber &&
        operatingDate &&
        timestamp &&
        // time close to now
        Math.abs(moment().diff(moment(timestamp))) < TASK_OTHER_TRAINS_PUNCTUALITY_CUTOFF_MS &&
        // time close to (or after) task start
        taskStart.diff(moment(timestamp)) < TASK_OTHER_TRAINS_PUNCTUALITY_CUTOFF_MS
    )

    if (trainsToFetch.length) {
      dispatch(
        fetchTrainPunctuality(
          trainsToFetch.map(({ trainNumber, operatingDate }) => ({
            trainNumber,
            trainDate: operatingDate,
          }))
        )
      )
    }

    // Due to how this page is constructed, changing the punctuality state will cause the page to
    // re-render. As the trains array is constructed dynamically below that, it would cause an
    // infinite loop in some cases. Simply only running the above dispatch when this component is
    // instantiated is far simpler than refactoring the punctuality state or parent components.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
